// import React from 'react';
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Skeleton,
//   Box,
//   Typography,
//   styled
// } from '@mui/material';
// import TableStatusLabel from './StatusLabel';

// // Styled components
// const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
//     width: '100%',
//     // boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)', 
//     border: "1px solid rgba(0, 0, 0, 0.12)", 
//     boxShadow:"none",
//     '&::-webkit-scrollbar': {
//       width: '6px',
//       height: '6px',
//     },
//     '&::-webkit-scrollbar-track': {
//       background: '#f1f1f1',
//       borderRadius: '3px',
//     },
//     '&::-webkit-scrollbar-thumb': {
//       background: '#888',
//       borderRadius: '3px',
//       '&:hover': {
//         background: '#555',
//       },
//     },
//   }));
  

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   backgroundColor: theme.palette.common.white,
//   '&.header': {
//     backgroundColor: theme.palette.grey[50],
//     fontWeight: 600,
//     borderBottom: `2px solid ${theme.palette.grey[200]}`,
//     zIndex: 1,
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   cursor: 'pointer',
//   '&:hover': {
//     backgroundColor: theme.palette.action.hover,
//   },
//   '&:last-child td, &:last-child th': {
//     // border: 0,
//   },
//   transition: theme.transitions.create(['background-color'], {
//     duration: theme.transitions.duration.shortest,
//   }),
// }));

// const StatusChip = styled('span')(({ theme, status }) => ({
//   padding: theme.spacing(1, 2),
//   borderRadius: '16px',
//   fontSize: '0.875rem',
//   display: 'inline-block',
//   ...(status === 'Approved' && {
//     backgroundColor: theme.palette.success.light,
//     color: theme.palette.success.dark,
//   }),
//   ...(status === 'Rejected' && {
//     backgroundColor: theme.palette.error.light,
//     color: theme.palette.error.dark,
//   }),
//   ...(status === 'Pending' && {
//     backgroundColor: theme.palette.warning.light,
//     color: theme.palette.warning.dark,
//   }),
// }));

// const NoDataBox = styled(Box)(({ theme }) => ({
//   width: '100%',
//   padding: theme.spacing(4),
//   textAlign: 'center',
//   backgroundColor: theme.palette.common.white,
//   borderRadius: theme.shape.borderRadius,
//   boxShadow: theme.shadows[3],
// }));

// const CustomTable = ({ 
//   headers = [], 
//   data = [], 
//   visibleColumns = [], 
//   onRowClick,
//   loading = false,
//   maxHeight = "680px"
// }) => {
//   const displayHeaders = visibleColumns.length > 0 
//     ? headers.filter(header => visibleColumns.includes(header.key))
//     : headers;

//   const handleRowClick = (rowData) => {
//     if (onRowClick) {
//       onRowClick(rowData);
//     }
//   };

//   if (loading) {
//     return (
//       <StyledTableContainer sx={{ maxHeight }}>
//         <Table stickyHeader>
//           <TableHead>
//             <TableRow>
//               {displayHeaders?.map((header, index) => (
//                 <StyledTableCell key={index} className="header">
//                   <Skeleton animation="wave" height={20} />
//                 </StyledTableCell>
//               ))}
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {[...Array(5)].map((_, rowIndex) => (
//               <StyledTableRow key={rowIndex}>
//                 {displayHeaders.map((_, colIndex) => (
//                   <StyledTableCell key={colIndex}>
//                     <Skeleton animation="wave" height={20} />
//                   </StyledTableCell>
//                 ))}
//               </StyledTableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </StyledTableContainer>
//     );
//   }

//   if (!data.length) {
//     return (
//       <NoDataBox>
//         <Typography variant="h6" color="textSecondary">
//           No data available
//         </Typography>
//       </NoDataBox>
//     );
//   }

//   return (
//     <StyledTableContainer  sx={{ maxHeight, borderBottom:"#ffff" }}>
//       <Table stickyHeader>
//         <TableHead>
//           <TableRow>
//             {displayHeaders?.map((header, index) => (
//               <StyledTableCell
//                 key={index}
//                 className="header"
//                 align={header.numeric ? 'right' : 'left'}
//               >
//                 {header.label}
//               </StyledTableCell>
//             ))}
//           </TableRow>
//         </TableHead>
//         <TableBody >
//           {data?.map((row, rowIndex) => (
//             <StyledTableRow
//               key={rowIndex}
//               onClick={() => handleRowClick(row)}
//             >
//               {displayHeaders?.map((header, colIndex) => (
//                 <StyledTableCell
//                   key={colIndex}
//                   align={header.numeric ? 'right' : 'left'}
//                   sx={{padding:"4px 10px "}}
//                 >
//                   {header.key === 'status' ? (
//                     // <StatusChip status={row[header.key]}>
//                     //   {row[header.key]}
//                     // </StatusChip>
//                     <TableStatusLabel status={row[header.key]}/>
//                   ) : (
//                     row[header.key]
//                   )}
//                 </StyledTableCell>
//               ))}
//             </StyledTableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </StyledTableContainer>
//   );
// };

// export default CustomTable;

import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
  Box,
  Typography,
  styled,
  IconButton
} from '@mui/material';
import TableStatusLabel from './StatusLabel';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

// Styled components
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: '100%',
  border: "1px solid rgba(0, 0, 0, 0.12)", 
  boxShadow:"none",
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '3px',
    '&:hover': {
      background: '#555',
    },
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  '&.header': {
    backgroundColor: theme.palette.grey[50],
    fontWeight: 600,
    borderBottom: `2px solid ${theme.palette.grey[200]}`,
    zIndex: 1,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    // border: 0,
  },
  transition: theme.transitions.create(['background-color'], {
    duration: theme.transitions.duration.shortest,
  }),
}));

const StatusChip = styled('span')(({ theme, status }) => ({
  padding: theme.spacing(1, 2),
  borderRadius: '16px',
  fontSize: '0.875rem',
  display: 'inline-block',
  ...(status === 'Approved' && {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.dark,
  }),
  ...(status === 'Rejected' && {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.dark,
  }),
  ...(status === 'Pending' && {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark,
  }),
}));

const NoDataBox = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(4),
  textAlign: 'center',
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
}));

const CustomTable = ({  
  headers = [], 
  data = [], 
  visibleColumns = [], 
  onRowClick,
  onEdit, 
  onDelete,
  loading = false,
  maxHeight = "680px",
  action =false,
  editBtn =true,
  deleteBtn=true
}) => {
  const displayHeaders = visibleColumns.length > 0 
    ? headers.filter(header => visibleColumns.includes(header.key))
    : headers;

  const handleRowClick = (rowData) => {
    if (onRowClick) {
      onRowClick(rowData);
    }
  };

  const handleEditClick = (event, rowData) => {
    event.stopPropagation();
    if (onEdit) {
      onEdit(rowData);
    }
  };

  const handleDeleteClick = (event, rowData) => {
    event.stopPropagation();
    if (onDelete) {
      onDelete(rowData);
    }
  };

  if (loading) {
    return (
      <StyledTableContainer sx={{ maxHeight }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {displayHeaders?.map((header, index) => (
                <StyledTableCell key={index} className="header">
                  <Skeleton animation="wave" height={20} />
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(5)].map((_, rowIndex) => (
              <StyledTableRow key={rowIndex}>
                {displayHeaders.map((_, colIndex) => (
                  <StyledTableCell key={colIndex}>
                    <Skeleton animation="wave" height={20} />
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </StyledTableContainer>
    );
  }

  if (!data.length) {
    return (
      <NoDataBox>
        <Typography variant="h6" color="textSecondary">
          No data available
        </Typography>
      </NoDataBox>
    );
  }

  return (
    <StyledTableContainer sx={{ maxHeight, borderBottom:"#ffff" }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {displayHeaders?.map((header, index) => (
              <StyledTableCell
                key={index}
                className="header"
                align={header.numeric ? 'right' : 'left'}
              >
                {header.label}
              </StyledTableCell>
            ))}
           {action && <StyledTableCell className="header" align="right">
              Actions
            </StyledTableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((row, rowIndex) => (
            <StyledTableRow
              key={rowIndex}
              onClick={() => handleRowClick(row)}
            >
              {displayHeaders?.map((header, colIndex) => (
                <StyledTableCell
                  key={colIndex}
                  align={header.numeric ? 'right' : 'left'}
                  sx={{padding:"4px 10px "}}
                >
                  {header.key === 'status' ? (
                    <TableStatusLabel status={row[header.key]}/>
                  ) : header.key === 'employeeImage' ? (
                    // Handle both React components and URL strings
                    typeof row[header.key] === 'object' && row[header.key] !== null ? (
                      // React component (from PayrollLeave)
                      row[header.key]
                    ) : row[header.key] ? (
                      // URL string (from Payslip)
                      <img
                        src={row[header.key]}
                        alt="Employee"
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          objectFit: 'cover',
                          border: '1px solid #e0e0e0'
                        }}
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = 'data:image/svg+xml;utf8,' + encodeURIComponent(
                            `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
                              <rect width="40" height="40" fill="#f0f0f0"/>
                              <circle cx="20" cy="15" r="8" fill="#c0c0c0"/>
                              <rect x="10" y="26" width="20" height="8" rx="4" fill="#d0d0d0"/>
                            </svg>`
                          );
                        }}
                      />
                    ) : (
                      <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#f0f0f0',
                        border: '1px solid #e0e0e0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <span style={{ fontSize: '12px', color: '#999' }}>N/A</span>
                      </div>
                    )
                  ) : (
                    row[header.key]
                  )}
                </StyledTableCell>
              ))}
             {action && <StyledTableCell align="right">
                {editBtn &&<IconButton onClick={(event) => handleEditClick(event, row)}>
                  <EditIcon />
                </IconButton>}
                {deleteBtn && <IconButton onClick={(event) => handleDeleteClick(event, row)}>
                  <DeleteIcon />
                </IconButton>}
              </StyledTableCell>}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

export default CustomTable;